// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Ddug","inputDescription":"styles_inputDescription__1laCz"};